import React from "react";
import { CalendarIcon } from "../../components/Primitives";
import { useAuthContext } from "../../providers/Auth/auth.provider";
import { AvailablePlatform, usePlatformContext } from "../../providers/Auth/platform.provider";
import config from "../../config/config";
import { getPomMainContactNavItems, getPomAdminNavItems } from "../../pom-navigation-items";
import { AvailablePomRoutes } from "../../utils/constants";
import { isAdmin, isPomAgency, isPomMainContact, canAccessReporting } from "../user/user";
import { MenuListItem } from "./menu-list-item.component";
import { SidebarMenuItem } from "./sidebar-menu-item.component";

export const SidebarPomMenu: React.VFC = () => {
  const { internalUser } = useAuthContext();
  const { activePlatform } = usePlatformContext();

  const isPomPlatform = () => activePlatform === AvailablePlatform.Pom;
  const pomNavItems = isAdmin(internalUser)
    ? getPomAdminNavItems(config.bcEditMasterDataUrl)
    : isPomMainContact(internalUser)
      ? getPomMainContactNavItems(internalUser?.group?.erpNumber, config.bcEditMasterDataUrl)
      : [];

  if (isPomPlatform() && !isPomAgency(internalUser) && !isAdmin(internalUser)) {
    return (
      <>
        {canAccessReporting(internalUser) && (
          <MenuListItem
            path={AvailablePomRoutes.Reporting}
            MenuIcon={CalendarIcon}
            title={"pom.reportings.page_title"}
          />
        )}
        {pomNavItems
          .filter((item) => item.visible && item.content)
          .map((item, index) => {
            return <SidebarMenuItem key={`pom-${item.to}-${index}`} name="pom" navItem={item} menuItem={item.label} />;
          })}
      </>
    );
  }
  return null;
};
